import script from "./CategorySetupEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySetupEdit.vue?vue&type=script&setup=true&lang=js"

import "./CategorySetupEdit.vue?vue&type=style&index=0&id=738f2eed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738f2eed"]])

export default __exports__